export const BASE = {
  name: 'surveys',
  path: '/sites/:siteId/surveys',
};

export const LIST = {
  name: 'surveys.list',
  path: `${BASE.path}/list`,
};

export const CREATE_BASE = {
  name: 'surveys.create',
  path: `${BASE.path}/create`,
};

export const CREATE = {
  name: 'surveys.create',
  path: `${BASE.path}/create/:copyId?templateId&category&activeFlowSection`,
};

export const EDIT_BASE = {
  name: 'surveys.edit',
  path: `${BASE.path}/edit/:surveyId`,
};

export const EDIT = {
  name: 'surveys.edit',
  path: `${BASE.path}/edit/:surveyId?activeFlowSection`,
};

export const RESPONSES_DEFAULT = {
  name: 'surveys.responses_default',
  path: `${BASE.path}/responses`,
};

export const RESPONSES = {
  name: 'surveys.responses',
  path: `${BASE.path}/responses/:surveyId`,
};

export const RESPONSE = {
  name: 'surveys.response',
  path: `${BASE.path}/responses/:surveyId?prid`,
};

export const RESULTS_DEFAULT = {
  name: 'surveys.results',
  path: `${BASE.path}/results`,
};

export const RESULTS = {
  name: 'surveys.results',
  path: `${BASE.path}/results/:surveyId`,
};

export const PERFORMANCE_DEFAULT = {
  name: 'surveys.performance',
  path: `${BASE.path}/performance`,
};

export const PERFORMANCE = {
  name: 'surveys.performance',
  path: `${BASE.path}/performance/:surveyId`,
};
